// @flow
import type { Element } from 'react'
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'

export type municipalitySearchProps = {
  lookupString: string,
  onSearchTermChange: Event => void
}

export function MunicipalitySearch ({
  lookupString,
  onSearchTermChange
}: municipalitySearchProps): Element<any> {
  return (
    <div className='ui fluid icon top attached input'>
      <input
        type='search'
        placeholder='Commune(s)'
        value={lookupString}
        onChange={onSearchTermChange}
      />
      <i className='search icon' />
    </div>
  )
}

export default MunicipalitySearch



// WEBPACK FOOTER //
// ./src/components/municipalitySearch/component.js